// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"f85349e6","527":"6859a453"}[chunkId] + ".chunk.js";
};